import type { WalkthroughRole } from './walkthroughTypes';

export type SupportTemplateKey =
  | 'homeowner_general'
  | 'homeowner_section'
  | 'homeowner_download'
  | 'contractor_general'
  | 'contractor_section'
  | 'contractor_download';

export interface HelpSupportTemplate {
  key: SupportTemplateKey;
  role: WalkthroughRole;
  subject: string;
  body: string;
}

// CB:BEGIN help-support-templates
export const helpSupportTemplates: HelpSupportTemplate[] = [
  {
    key: 'homeowner_general',
    role: 'homeowner',
    subject: 'CoreBids Help Center',
    body: 'Hi {{name}},\n\nHere is the Homeowner Help Center link for your project flow:\n{{link}}\n\nIt includes step-by-step guidance for project submission, bids, payments, milestones, and completion.\n\nBest,\nCoreBids Support',
  },
  {
    key: 'homeowner_section',
    role: 'homeowner',
    subject: 'CoreBids Help - {{sectionTitle}}',
    body: 'Hi {{name}},\n\nHere is the exact Help section for your current step ({{sectionTitle}}):\n{{link}}\n\nFollow the “What to click” and “What happens next” guidance in that section.\n\nBest,\nCoreBids Support',
  },
  {
    key: 'homeowner_download',
    role: 'homeowner',
    subject: 'CoreBids Homeowner Walkthrough',
    body: 'Hi {{name}},\n\nHere is the homeowner walkthrough file:\n{{link}}\n\nUse this as a visual guide while you complete each project step.\n\nBest,\nCoreBids Support',
  },
  {
    key: 'contractor_general',
    role: 'contractor',
    subject: 'CoreBids Contractor Help Center',
    body: 'Hi {{name}},\n\nHere is the Contractor Help Center:\n{{link}}\n\nIt covers finding projects, submitting bids, milestones, and completion.\n\nBest,\nCoreBids Support',
  },
  {
    key: 'contractor_section',
    role: 'contractor',
    subject: 'CoreBids Help - {{sectionTitle}}',
    body: 'Hi {{name}},\n\nHere is the exact Help section for your current step ({{sectionTitle}}):\n{{link}}\n\nThis should help you complete the next action quickly.\n\nBest,\nCoreBids Support',
  },
  {
    key: 'contractor_download',
    role: 'contractor',
    subject: 'CoreBids Contractor Walkthrough',
    body: 'Hi {{name}},\n\nHere is the contractor walkthrough file:\n{{link}}\n\nUse it as a visual guide for bidding, execution, and milestone flow.\n\nBest,\nCoreBids Support',
  },
];
// CB:END help-support-templates

export const getSupportTemplate = (key: SupportTemplateKey) =>
  helpSupportTemplates.find((template) => template.key === key);

